import { FC, useMemo } from 'react';

import { DOT } from 'utils/constants/common';

import { Link, Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';
import { useDashboardRoute } from 'hooks/useDashboardRoute';

import styles from 'pages/AdCopyPage/AdCopyPage.module.less';

import { BannerBuilder } from 'components/BannerBuilder/BannerBuilder';
import { PageContentHeader } from 'components/common/PageContentHeader/PageContentHeader';
import { Header } from 'components/Header/Header';

import { useSelector } from 'store/utils';

const TrlKeys = {
    dashboard: 'AdCreatePage.breadcrumbs.dashboard',
    create: 'BannerForm.title',
    edit: 'BannerForm.titleEdit',
};

export const BannerBuilderPage: FC = () => {
    const { bannerVacancyId, bannerLink, vacancyName, bannerId } = useSelector((state) => state.createBanner);

    const trls = useTrls();
    const dashboardRoute = useDashboardRoute();

    const title = trls(bannerId ? TrlKeys.edit : TrlKeys.create);

    const breadcrumbs = useMemo(
        () => [
            {
                to: dashboardRoute,
                children: trls(TrlKeys.dashboard),
            },
            { to: '#', children: title },
        ],
        [dashboardRoute, trls, title]
    );

    return (
        <div className={styles.wrapper}>
            <Header />
            <PageContentHeader
                breadcrumbsConfig={breadcrumbs}
                title={title}
                additionalContent={
                    bannerLink &&
                    (bannerVacancyId ? (
                        <Link
                            href={`https://hh.ru/vacancy/${bannerVacancyId}`}
                            target="_blank"
                            data-qa="header-vacancy-link"
                        >
                            {`${vacancyName} ${DOT} ID ${bannerVacancyId}`}
                        </Link>
                    ) : (
                        <Link href={bannerLink} target="_blank" data-qa="header-banner-link" overflowWrap="anywhere">
                            <Text maxLines={1}>{bannerLink}</Text>
                        </Link>
                    ))
                }
                vSpacingBottom={24}
            />
            <BannerBuilder />
        </div>
    );
};
